module.exports = __webpack_public_path__ + "img/Fabric_trading_1200x800.b4a417da.png";